// extracted by mini-css-extract-plugin
export default {"container":"menu_container__J8WSn","close_box":"menu_close_box__Iizsj","close_btn":"menu_close_btn__nbC+m"};